import type { Apis } from '@efdigital/ll-addon-auth/types/apis';
import config from '@efdigital/ll-admin-v2/config/environment';
import type { ConstrainedRequestOptions } from '@warp-drive/core/types/request';

const apis: Apis = config['ll-addon-auth-apis'];

export const jsonApiOptions: ConstrainedRequestOptions = apis.jsonApi;
